export default {
  cart: () => import("/app/layouts/cart.vue"),
  default: () => import("/app/layouts/default.vue")
}